<div class="removed-items" *ngIf="removedItems$ | async as removedItems">
  <!-- Toolbar with Restore All button -->
  <div class="removed-items-toolbar" *ngIf="removedItems.length > 0">
    <sui-button
      variant="danger"
      [leadingIcon]="['fas', 'trash-arrow-up']"
      (click)="removeAllItems()"
    >
      {{ "filters.button.restore-all" | translate }}
    </sui-button>
  </div>

  <ng-container *ngIf="removedItems.length > 0; else noRemovedItems">
    <div
      class="removed-item"
      *ngFor="let item of removedItems; trackBy: trackByRemovedItem"
    >
      <!-- Type icon (SOURCE vs POST) -->
      <fa-icon
        class="type-icon"
        [icon]="
          item.object_class_id === NomObjectClass.SOURCE
            ? ['fas', 'rss']
            : ['fas', 'newspaper']
        "
        [title]="
          item.object_class_id === NomObjectClass.SOURCE ? 'Source' : 'Article'
        "
        aria-hidden="true"
      ></fa-icon>

      <div class="title">
        <a href="{{ item.url }}" target="_blank">{{ item.title }}</a>
      </div>

      <!-- Remove action -->
      <fa-icon
        class="remove-icon"
        [icon]="['fas', 'trash-arrow-up']"
        (click)="removeSingleItem(item)"
        title="Restore"
      ></fa-icon>
    </div>
  </ng-container>

  <ng-template #noRemovedItems>
    <div class="no-items-message">
      {{ "removed-items.message.there-are-no-removed-items" | translate }}
    </div>
  </ng-template>
</div>
